<template>
  <component
    :is="href ? 'a' : 'button'"
    :type="href ? null : 'button'"
    :href="href || null"
    :target="href && newTab ? '_blank' : null"
    :rel="href && newTab ? 'noopener' : null"
    class="m-sheet-item"
    :class="{ 'is-danger': danger, 'is-separated': separated }"
    :disabled="href ? null : disabled"
    @click="$emit('click', $event)"
  >
    <i :class="['fas', 'fa-' + icon, { 'fa-spin': spin }]" aria-hidden="true"></i>
    <span class="m-sheet-item__label">{{ label }}</span>
    <span v-if="hint" class="m-sheet-item__hint">{{ hint }}</span>
  </component>
</template>

<script>
/**
 * Renglón de acción de una MobileBottomSheet. `danger` + `separated` para lo destructivo.
 * Con `href` es un link (`newTab` lo abre en otra pestaña).
 */
export default {
  name: "MobileSheetItem",
  props: {
    icon: { type: String, required: true },
    label: { type: String, required: true },
    hint: { type: [String, Number], default: "" },
    danger: { type: Boolean, default: false },
    separated: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    spin: { type: Boolean, default: false },
    href: { type: String, default: "" },
    newTab: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.m-sheet-item {
  box-sizing: border-box;
  width: 100%;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.9rem;
  min-height: 3rem;
  padding: 0.5rem 1.1rem;
  border: 0;
  border-bottom: 1px solid var(--m-border);
  background: transparent;
  color: var(--m-text);
  text-align: left;
  font-size: 0.98rem;
}
.m-sheet-item > i {
  width: 1.25rem;
  text-align: center;
  color: var(--m-muted);
}
.m-sheet-item:active {
  background: var(--m-surface-2);
}
.m-sheet-item:disabled {
  opacity: 0.5;
}
.m-sheet-item__label {
  flex: 1;
}
.m-sheet-item__hint {
  color: var(--m-muted);
  font-size: 0.85rem;
}
.m-sheet-item.is-separated {
  margin-top: 0.5rem;
  border-top: 1px solid var(--m-border);
}
.m-sheet-item.is-danger,
.m-sheet-item.is-danger > i {
  color: var(--bs-danger);
}
</style>
